import React, { useState, useEffect } from "react";
import Content from "../../../layout/content/Content";
import Head from "../../../layout/head/Head";
import {
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
  Modal,
  ModalBody,
  DropdownItem,
} from "reactstrap";
import {
  Block,
  BlockHead,
  BlockBetween,
  BlockHeadContent,
  BlockTitle,
  BlockDes,
  Icon,
  Button,
  DataTable,
  DataTableBody,
  DataTableHead,
  DataTableRow,
  DataTableItem,
  PaginationComponent,
  UserAvatar,
  RSelect,
  Col,
} from "../../../components/Component";
import { api } from "../../../utils/api";
import { findUpper } from "../../../utils/Utils";
import { toast } from "react-toastify";
import { Badge, Spinner, Input } from "reactstrap";
import { PreviewCard } from "../../../components/Component";

const ActivityLogHistory = () => {
  const [sm, updateSm] = useState(false);
  const [modal, setModal] = useState({ view: false });
  const [viewActivity, setViewActivity] = useState(null);
  const [activities, setActivities] = useState([]);
  const [statistics, setStatistics] = useState(null);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [filters, setFilters] = useState({
    subject_type: "all",
    event: "all",
    log_name: "all",
    start_date: "",
    end_date: "",
    hse_process: false,
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage] = useState(15);
  const [totalItems, setTotalItems] = useState(0);

  useEffect(() => {
    loadActivities();
    loadStatistics();
  }, [currentPage, searchText, filters]);

  const loadActivities = async () => {
    setLoading(true);
    try {
      const params = { page: currentPage, per_page: itemPerPage };
      if (searchText) params.search = searchText;
      if (filters.subject_type && filters.subject_type !== "all") params.subject_type = filters.subject_type;
      if (filters.event && filters.event !== "all") params.event = filters.event;
      if (filters.log_name && filters.log_name !== "all") params.log_name = filters.log_name;
      if (filters.start_date) params.start_date = filters.start_date;
      if (filters.end_date) params.end_date = filters.end_date;
      if (filters.hse_process) params.hse_process = 1;

      const response = await api.getActivityLogs(params);
      if (response.data) {
        setActivities(response.data);
        setTotalItems(response.total || 0);
      } else {
        setActivities(response);
        setTotalItems(response.length || 0);
      }
    } catch (error) {
      toast.error("Erreur lors du chargement de l'historique");
      setActivities([]);
      setTotalItems(0);
    } finally {
      setLoading(false);
    }
  };

  const loadStatistics = async () => {
    try {
      const params = {};
      if (filters.start_date) params.start_date = filters.start_date;
      if (filters.end_date) params.end_date = filters.end_date;
      const response = await api.getActivityLogStatistics(params);
      setStatistics(response);
    } catch (error) {
      // Ignorer l'erreur
    }
  };

  const onViewClick = async (id) => {
    try {
      const activity = await api.getActivityLog(id);
      setViewActivity(activity);
      setModal({ view: true });
    } catch (error) {
      toast.error("Erreur lors du chargement de l'activité");
    }
  };

  const EVENT_LABELS = {
    created: "Créé",
    updated: "Modifié",
    deleted: "Supprimé",
    restored: "Restauré",
    unknown: "Inconnu",
  };

  const SUBJECT_TYPE_LABELS = {
    User: "Utilisateur",
    Observation: "Observation",
    Site: "Site",
    Company: "Entreprise",
    Role: "Rôle",
    Badge: "Badge",
    Permit: "Permis",
    MocRequest: "MOC",
    Incident: "Incident",
    Inspection: "Inspection",
  };

  const getEventLabel = (event) => EVENT_LABELS[event] || event || EVENT_LABELS.unknown;
  const getActionLabel = (description, event) => {
    if (!description) return "-";
    const d = String(description).toLowerCase().trim();
    if (EVENT_LABELS[d]) return EVENT_LABELS[d];
    if (event && EVENT_LABELS[event]) return EVENT_LABELS[event];
    return description;
  };
  const getSubjectTypeLabel = (type) => {
    if (!type) return "-";
    const typeName = type.split("\\").pop();
    return SUBJECT_TYPE_LABELS[typeName] || typeName;
  };

  const getEventBadge = (event) => {
    const eventColors = {
      created: "success",
      updated: "primary",
      deleted: "danger",
      restored: "warning",
    };
    return <Badge color={eventColors[event] || "secondary"}>{getEventLabel(event)}</Badge>;
  };

  const getSubjectTypeBadge = (type) => {
    if (!type) return <span className="text-soft">-</span>;
    const typeName = type.split("\\").pop();
    const label = getSubjectTypeLabel(type);
    return <Badge color="info">{label}</Badge>;
  };

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <React.Fragment>
      <Head title="Historique des actions" />
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Historique des actions</BlockTitle>
              <BlockDes className="text-soft">Consultez l'historique complet des actions du système</BlockDes>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <Button
                  className={`btn-icon btn-trigger toggle-expand me-n1 ${sm ? "active" : ""}`}
                  onClick={() => updateSm(!sm)}
                >
                  <Icon name="menu-alt-r"></Icon>
                </Button>
                <div className="toggle-expand-content" style={{ display: sm ? "block" : "none" }}>
                  <ul className="nk-block-tools g-3">
                    <li>
                      <div className="form-control-wrap">
                        <div className="form-icon form-icon-left">
                          <Icon name="search"></Icon>
                        </div>
                        <Input
                          type="text"
                          className="form-control"
                          placeholder="Rechercher..."
                          value={searchText}
                          onChange={(e) => {
                            setSearchText(e.target.value);
                            setCurrentPage(1);
                          }}
                          style={{ minWidth: "250px" }}
                        />
                      </div>
                    </li>
                    <li>
                      <UncontrolledDropdown>
                        <DropdownToggle tag="a" className="dropdown-toggle btn btn-white btn-dim btn-outline-light">
                          <Icon name="filter-alt" className="d-none d-sm-inline"></Icon>
                          <span>Filtrer</span>
                          <Icon name="chevron-right" className="dd-indc"></Icon>
                        </DropdownToggle>
                        <DropdownMenu end>
                          <ul className="link-list-opt no-bdr">
                            <li>
                              <DropdownItem tag="div" className="px-3 py-2">
                                <label className="form-label small">Type de sujet</label>
                                <RSelect
                                  options={[
                                    { value: "all", label: "Tous" },
                                    { value: "App\\Models\\User", label: "Utilisateur" },
                                    { value: "App\\Models\\Observation", label: "Observation" },
                                    { value: "App\\Models\\Site", label: "Site" },
                                  ]}
                                  value={{ value: filters.subject_type, label: filters.subject_type === "all" ? "Tous" : getSubjectTypeLabel(filters.subject_type) }}
                                  onChange={(e) => {
                                    setFilters({ ...filters, subject_type: e.value });
                                    setCurrentPage(1);
                                  }}
                                />
                              </DropdownItem>
                            </li>
                            <li>
                              <DropdownItem tag="div" className="px-3 py-2">
                                <label className="form-label small">Événement</label>
                                <RSelect
                                  options={[
                                    { value: "all", label: "Tous" },
                                    { value: "created", label: "Créé" },
                                    { value: "updated", label: "Modifié" },
                                    { value: "deleted", label: "Supprimé" },
                                    { value: "restored", label: "Restauré" },
                                  ]}
                                  value={{ value: filters.event, label: filters.event === "all" ? "Tous" : getEventLabel(filters.event) }}
                                  onChange={(e) => {
                                    setFilters({ ...filters, event: e.value });
                                    setCurrentPage(1);
                                  }}
                                />
                              </DropdownItem>
                            </li>
                            <li>
                              <DropdownItem tag="div" className="px-3 py-2">
                                <label className="form-label small">Date début</label>
                                <Input
                                  type="date"
                                  value={filters.start_date}
                                  onChange={(e) => {
                                    setFilters({ ...filters, start_date: e.target.value });
                                    setCurrentPage(1);
                                  }}
                                />
                              </DropdownItem>
                            </li>
                            <li>
                              <DropdownItem tag="div" className="px-3 py-2">
                                <label className="form-label small">Date fin</label>
                                <Input
                                  type="date"
                                  value={filters.end_date}
                                  onChange={(e) => {
                                    setFilters({ ...filters, end_date: e.target.value });
                                    setCurrentPage(1);
                                  }}
                                />
                              </DropdownItem>
                            </li>
                            <li>
                              <DropdownItem tag="div" className="px-3 py-2">
                                <label className="d-flex align-items-center gap-2 mb-0" style={{ cursor: "pointer" }}>
                                  <Input
                                    type="checkbox"
                                    checked={filters.hse_process}
                                    onChange={(e) => {
                                      setFilters({ ...filters, hse_process: e.target.checked });
                                      setCurrentPage(1);
                                    }}
                                  />
                                  <span className="small">Audit processus HSE (permis, MOC, incidents…)</span>
                                </label>
                              </DropdownItem>
                            </li>
                          </ul>
                        </DropdownMenu>
                      </UncontrolledDropdown>
                    </li>
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        {statistics && (
          <Block>
            <div className="row g-gs">
              <Col md="4">
                <div className="card border-0 bg-light">
                  <div className="card-body">
                    <div className="d-flex align-items-center">
                      <div className="flex-grow-1">
                        <span className="sub-text d-block">Total activités</span>
                        <h4 className="mb-0">{statistics.total_activities || 0}</h4>
                      </div>
                      <Icon name="activity" className="text-primary" style={{ fontSize: "2rem" }}></Icon>
                    </div>
                  </div>
                </div>
              </Col>
              <Col md="4">
                <div className="card border-0 bg-light">
                  <div className="card-body">
                    <div className="d-flex align-items-center">
                      <div className="flex-grow-1">
                        <span className="sub-text d-block">Types d'événements</span>
                        <h4 className="mb-0">{statistics.events?.length || 0}</h4>
                      </div>
                      <Icon name="layers" className="text-info" style={{ fontSize: "2rem" }}></Icon>
                    </div>
                  </div>
                </div>
              </Col>
              <Col md="4">
                <div className="card border-0 bg-light">
                  <div className="card-body">
                    <div className="d-flex align-items-center">
                      <div className="flex-grow-1">
                        <span className="sub-text d-block">Types de sujets</span>
                        <h4 className="mb-0">{statistics.subject_types?.length || 0}</h4>
                      </div>
                      <Icon name="file-text" className="text-success" style={{ fontSize: "2rem" }}></Icon>
                    </div>
                  </div>
                </div>
              </Col>
            </div>
          </Block>
        )}

        <Block>
          <DataTable className="card-stretch">
            <DataTableBody>
              <DataTableHead className="nk-tb-item nk-tb-head">
                <DataTableRow>
                  <span className="sub-text">Date</span>
                </DataTableRow>
                <DataTableRow>
                  <span className="sub-text">Utilisateur</span>
                </DataTableRow>
                <DataTableRow>
                  <span className="sub-text">Action</span>
                </DataTableRow>
                <DataTableRow>
                  <span className="sub-text">Type</span>
                </DataTableRow>
                <DataTableRow>
                  <span className="sub-text">Événement</span>
                </DataTableRow>
                <DataTableRow className="nk-tb-col-tools text-end"></DataTableRow>
              </DataTableHead>
              {loading ? (
                <DataTableItem>
                  <DataTableRow>
                    <DataTableItem colSpan={6} className="text-center">
                      <Spinner color="primary" />
                    </DataTableItem>
                  </DataTableRow>
                </DataTableItem>
              ) : activities.length === 0 ? (
                <DataTableItem>
                  <DataTableRow>
                    <DataTableItem colSpan={6} className="text-center">
                      <PreviewCard>
                        <div className="text-center py-4">
                          <span className="text-soft">Aucune activité trouvée</span>
                        </div>
                      </PreviewCard>
                    </DataTableItem>
                  </DataTableRow>
                </DataTableItem>
              ) : (
                activities.map((activity) => (
                  <DataTableItem key={activity.id}>
                    <DataTableRow>
                      <span>{new Date(activity.created_at).toLocaleString('fr-FR')}</span>
                    </DataTableRow>
                    <DataTableRow>
                      {activity.causer ? (
                        <div className="d-flex align-items-center">
                          <UserAvatar
                            className="me-2"
                            size="sm"
                            theme="blue"
                            text={findUpper(activity.causer.name || "S")}
                          />
                          <div>
                            <span className="tb-lead">{activity.causer.name || "Système"}</span>
                            {activity.causer.email && (
                              <span className="sub-text d-block">{activity.causer.email}</span>
                            )}
                          </div>
                        </div>
                      ) : (
                        <span className="text-soft">Système</span>
                      )}
                    </DataTableRow>
                    <DataTableRow>
                      <span className="tb-lead">{getActionLabel(activity.description, activity.event)}</span>
                    </DataTableRow>
                    <DataTableRow>
                      {getSubjectTypeBadge(activity.subject_type)}
                    </DataTableRow>
                    <DataTableRow>
                      {getEventBadge(activity.event)}
                    </DataTableRow>
                    <DataTableRow className="nk-tb-col-tools">
                      <ul className="nk-tb-actions gx-1">
                        <li>
                          <button
                            className="btn btn-trigger btn-icon"
                            onClick={() => onViewClick(activity.id)}
                            data-bs-toggle="tooltip"
                            data-bs-placement="top"
                            title="Voir les détails"
                          >
                            <Icon name="eye"></Icon>
                          </button>
                        </li>
                      </ul>
                    </DataTableRow>
                  </DataTableItem>
                ))
              )}
            </DataTableBody>
            <div className="card-inner">
              {totalItems > 0 && (
                <PaginationComponent
                  itemPerPage={itemPerPage}
                  totalItems={totalItems}
                  paginate={paginate}
                  currentPage={currentPage}
                />
              )}
            </div>
          </DataTable>
        </Block>

        {/* Modal View Activity */}
        <Modal isOpen={modal.view} toggle={() => setModal({ view: false })} className="modal-dialog-centered" size="lg">
          {viewActivity && (
            <>
              <div className="modal-header border-bottom">
                <div className="d-flex align-items-center justify-content-between w-100">
                  <div>
                    <h5 className="modal-title mb-1">Détails de l'activité</h5>
                    <div className="d-flex mt-2">
                      {getEventBadge(viewActivity.event)}
                      {getSubjectTypeBadge(viewActivity.subject_type)}
                    </div>
                  </div>
                  <button className="close" onClick={() => setModal({ view: false })}>
                    <Icon name="cross"></Icon>
                  </button>
                </div>
              </div>
              <ModalBody className="p-4">
                <div className="row g-4">
                  <Col md="12">
                    <div className="card border-0 bg-light">
                      <div className="card-body p-4">
                        <h6 className="title mb-3">
                          <Icon name="info" className="me-2"></Icon>
                          Description
                        </h6>
                        <p>{getActionLabel(viewActivity.description, viewActivity.event)}</p>
                      </div>
                    </div>
                  </Col>

                  <Col md="6">
                    <div className="card border-0 bg-light">
                      <div className="card-body p-4">
                        <h6 className="title mb-3">
                          <Icon name="user" className="me-2"></Icon>
                          Utilisateur
                        </h6>
                        {viewActivity.causer ? (
                          <div>
                            <p className="mb-1"><strong>Nom:</strong> {viewActivity.causer.name || "Système"}</p>
                            {viewActivity.causer.email && (
                              <p className="mb-0"><strong>Email:</strong> {viewActivity.causer.email}</p>
                            )}
                          </div>
                        ) : (
                          <p className="mb-0">Système</p>
                        )}
                      </div>
                    </div>
                  </Col>

                  <Col md="6">
                    <div className="card border-0 bg-light">
                      <div className="card-body p-4">
                        <h6 className="title mb-3">
                          <Icon name="calendar" className="me-2"></Icon>
                          Date
                        </h6>
                        <p className="mb-0">
                          {new Date(viewActivity.created_at).toLocaleString('fr-FR', {
                            year: 'numeric',
                            month: 'long',
                            day: 'numeric',
                            hour: '2-digit',
                            minute: '2-digit'
                          })}
                        </p>
                      </div>
                    </div>
                  </Col>

                  {viewActivity.properties && Object.keys(viewActivity.properties).length > 0 && (
                    <Col md="12">
                      <div className="card border-0 bg-light">
                        <div className="card-body p-4">
                          <h6 className="title mb-3">
                            <Icon name="file-text" className="me-2"></Icon>
                            Propriétés
                          </h6>
                          <pre className="bg-white p-3 rounded" style={{ maxHeight: "300px", overflow: "auto" }}>
                            {JSON.stringify(viewActivity.properties, null, 2)}
                          </pre>
                        </div>
                      </div>
                    </Col>
                  )}
                </div>

                <div className="mt-4 text-end">
                  <Button color="light" onClick={() => setModal({ view: false })}>
                    Fermer
                  </Button>
                </div>
              </ModalBody>
            </>
          )}
        </Modal>
      </Content>
    </React.Fragment>
  );
};

export default ActivityLogHistory;

